import { useEffect } from 'react';
import { useGetMemberInformationQueryQuery } from 'src/modules/user/documents/getMemberInformationQuery.generated';
import { captureException } from 'src/shared/helpers/captureException';

/*
To search whether a key is present in member shared preferences
*/
export const useSharedPreferences = (key: string, value?: string) => {
    const {
        data: memberInfo,
        error,
        loading,
    } = useGetMemberInformationQueryQuery({
        fetchPolicy: 'cache-first',
    });

    useEffect(() => {
        if (error) {
            captureException(error);
        }
    }, [error]);

    useEffect(() => {
        if (loading || !memberInfo) {
            captureException(
                new Error('Failed to load shared preferences from cache, defaulting to false'),
                { loading },
            );
        }
    }, [loading, memberInfo]);

    const memberInfoSharedPreferences = memberInfo?.me?.sharedPreferences;

    return (
        memberInfoSharedPreferences?.some(info => {
            if (!info) return false;
            if (value) {
                return info.key === key && info.value === value;
            }
            return info.key === key;
        }) ?? false
    );
};
